export const TRIPS_KEY = 'alco-log-trips-v1'
const validDate = value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(`${value}T00:00:00Z`)) && new Date(`${value}T00:00:00Z`).toISOString().slice(0,10) === value
export function meter(value) {
  if (value === null || value === undefined || String(value).trim() === '' || !/^\d{1,7}(\.\d)?$/.test(String(value))) return null
  const number = Number(value)
  return number <= 9999999 ? number : null
}
export function distance(trip) {
  const start = meter(trip.startKm), end = meter(trip.endKm)
  return start === null || end === null || end < start ? null : Math.round((end - start) * 10) / 10
}
export function latestReturn(trips, vehicleId, at) {
  return trips.filter(t => t.vehicleId === vehicleId && t.endedAt && t.endedAt <= at && distance(t) !== null)
    .sort((a, b) => b.endedAt.localeCompare(a.endedAt) || b.id.localeCompare(a.id))[0] || null
}
export function linkedChecks(trip, records) {
  return records.filter(r => r.date === trip.date && r.driverId === trip.driverId && r.vehicleId === trip.vehicleId)
}
export function checkSummary(trip, records) {
  const linked = linkedChecks(trip, records)
  return ['業務前', '業務後'].map(phase => {
    const rows = linked.filter(r => r.phase === phase)
    return `${phase}：${!rows.length ? '未実施' : rows.some(r => r.status !== 'completed') ? '要確認' : '確認済み'}`
  }).join('／')
}
export function inspectionSummary(trip, records) {
  const checks = linkedChecks(trip, records).filter(r => r.preDriveCheck)
  return !checks.length ? '未実施' : checks.some(r => r.preDriveCheck.status === 'review') ? '要確認' : '良好'
}
export function startTrip(trips, input, now = new Date().toISOString()) {
  if (!input.driverId || !input.vehicleId || !validDate(input.date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(input.time)) throw new Error('日付・時刻・車両を確認してください')
  const startedAt = `${input.date}T${input.time}:00+09:00`
  if (trips.some(t => t.vehicleId === input.vehicleId && !t.endedAt)) throw new Error('この車両には帰着未入力の記録があります。先に帰着を登録してください。')
  if (trips.some(t => t.vehicleId === input.vehicleId && t.endedAt > startedAt)) throw new Error('この出発日時より後の車両記録があります。日時を確認してください。')
  const source = latestReturn(trips, input.vehicleId, startedAt)
  const startKm = meter(input.startKm)
  if (startKm === null || !input.confirmed) throw new Error('出発時メーターを実車で確認してください')
  if (source && startKm !== source.endKm && !input.reason?.trim()) throw new Error('引き継ぎ値と異なる理由を入力してください')
  if (source && input.sourceId !== source.id) throw new Error('直近の記録が更新されました。画面を開き直して確認してください。')
  const trip = { id: `trip-${crypto.randomUUID()}`, date: input.date, driverId: input.driverId, vehicleId: input.vehicleId,
    startedAt, endedAt: null, startKm, endKm: null, work: '', note: '', sourceId: source?.id || null,
    inheritedKm: source?.endKm ?? null, correctionReason: input.reason?.trim() || '', createdAt: now,
    audit: [`${now} 出発記録：${startKm} km${source ? `（引継元 ${source.id}）` : '（初回入力）'}`] }
  return [...trips, trip]
}
export function finishTrip(trips, id, input, now = new Date().toISOString()) {
  const trip = trips.find(t => t.id === id)
  if (!trip || trip.endedAt) throw new Error('記録が見つからないか、すでに帰着済みです')
  if (trip.driverId !== input.driverId) throw new Error('出発を記録したドライバーで帰着を登録してください')
  if (!validDate(input.date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(input.time)) throw new Error('帰着日時を確認してください')
  const endedAt = `${input.date}T${input.time}:00+09:00`, endKm = meter(input.endKm)
  if (endedAt < trip.startedAt) throw new Error('帰着日時は出発日時以降にしてください')
  if (endKm === null || endKm < trip.startKm) throw new Error('帰着メーターは出発メーター以上の値を入力してください')
  if (!input.work?.trim()) throw new Error('配送先・作業内容を入力してください')
  if (input.inspectionReview && !input.note?.trim()) throw new Error('車両点検に異常があります。異常・連絡事項を入力してください')
  return trips.map(t => t.id === id ? { ...t, endKm, endedAt, work: input.work.trim(), note: input.note?.trim() || '',
    audit: [...t.audit, `${now} 帰着記録：${endKm} km／走行 ${distance({ ...t, endKm })} km`] } : t)
}
export function summarizeTrips(trips, key) {
  const groups = new Map()
  for (const trip of trips) {
    const group = groups.get(trip[key]) || { id: trip[key], count: 0, pending: 0, km: 0 }
    const km = distance(trip)
    group.count++; if (km === null) group.pending++; else group.km = Math.round((group.km + km) * 10) / 10
    groups.set(group.id, group)
  }
  return [...groups.values()]
}
